<template>
  <div>
     {{ cTime }}
  </div>
</template>

<script>
import moment from "moment";
export default {
    props: {
        expiry: null,
        vault: null,
    },
    data() {
        return {
            cTime: "---",
            interval: null,
        }
    },
    methods:{
         moment,
         countdown() {
            if(!this.expiry) {
                this.cTime = `-`;
                return;
            }
            var startDate = this.moment(this.expiry, 'YYYY-MM-DD HH:mm').toDate();

            var countDownDate = new Date(
                startDate
            ).getTime();

            var offset = new Date().getTimezoneOffset();

            countDownDate = countDownDate - offset *60000;

            var checkdate = new Date(countDownDate);

            // Update the count down every 1 second
            this.interval = setInterval(() => {
                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor(
                    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                );
                var minutes = Math.floor(
                    (distance % (1000 * 60 * 60)) / (1000 * 60)
                );
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);

                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(this.interval);
                    this.cTime = "OPEN NOW";
                }else{
                    this.cTime = `${days}d ${hours}h ${minutes}m ${seconds}s`;
                }
            }, 1000);
        },
    },
    beforeDestroy(){
        this.interval = null;
    },
    mounted(){
        this.countdown();
    },
    watch: {
        vault(nv, ov) {
            // restart countdown if there are changes to vault object
            clearInterval(this.interval);
            this.countdown();
        }
    },
}
</script>

<style>

</style>
